import apiClient from './index'

export async function technicianJoinedMeeting(data) {
  return apiClient
    .post('/web-socket/technician-joined-meeting', data)
    .then((response) => {
      if (response) {
        return response.data
      }
      return Promise.reject()
    })
}

export async function customerJoinedMeeting(data) {
  return apiClient
    .post('/web-socket/customer-joined-meeting', data)
    .then((response) => {
      if (response) {
        return response.data
      }
      return Promise.reject()
    })
}
